export const PAGES = ['Category', 'Brand', 'Model', 'Issues', 'Enter Contact Details', 'Select Store', 'Confirm your Request']
export const DISPLAYING_PAGES = {
    PRODUCT:'PRODUCT',
    FORM:'FORM',
    BOOKING:'BOOKING',
    COMPLETION:'COMPLETION'
}
export const PROGRESS_STATE = [1,2,3,4,5,6,7]
